__turbopack_context__.v({
  "slotItem": "r_6Yda_slotItem",
  "slotItemFreeForCart": "r_6Yda_slotItemFreeForCart",
});
